<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { useSlots } from 'vue';
import type { CombinedError } from '@urql/vue';

import AlertError from './NoDataUrql/AlertError.vue';
import Loading from './Loading.vue';

defineProps<{
  fetching?: boolean,
  error?: CombinedError,
  title?: string,
  class?: HTMLAttributes['class'],
}>();

const slots = useSlots();
</script>

<template>
  <AlertError v-if="error" :error="error" :class="$props.class" />
  <Loading v-else :title="title" :class="$props.class">
    <template v-if="slots.loading" #default>
      <slot name="loading" />
    </template>
  </Loading>
</template>
